(() => {
  const body = document.querySelector('.shopify-policy__body .rte');
  if (!body) return;
  // Remove empty editor spacer blocks; CSS supplies consistent paragraph spacing.
  [...body.querySelectorAll('p, div')].reverse().forEach(el => {
    if (!el.textContent.trim() && !el.querySelector('img,video,iframe')) el.remove();
  });
  if (location.pathname.endsWith('/terms-of-service')) {
    body.querySelectorAll('a').forEach(a => {
      const path = new URL(a.href).pathname.replace(/\/$/, '');
      if (path === '/contact-us') a.href = '/pages/contact';
      if (path === '/privacy-policy') a.href = '/policies/privacy-policy';
    });
    [...body.children].forEach(el => {
      if (/^6\.1\s/.test(el.textContent.trim()) && el.textContent.includes('we are unable to accept returns on most items')) {
        el.replaceChildren();
        const number = document.createElement('strong'); number.textContent = '6.1 ';
        const policy = document.createElement('a'); policy.href = '/policies/refund-policy'; policy.textContent = 'Refund Policy';
        el.append(number, 'We accept change-of-mind returns within 30 days of delivery when the item is unopened, unused and in its original packaging. For an eligible change-of-mind return, you may choose a refund or exchange. This does not limit your rights under the Australian Consumer Law. Refer to our ', policy, ' for full terms and conditions, including faulty, damaged or incorrect items.');
      }
      if (el.tagName === 'DIV' && (/^\d+\.\s+\D/.test(el.textContent.trim()) || el.textContent.trim() === 'Any questions?')) {
        const heading = document.createElement('h2');
        heading.innerHTML = el.innerHTML;
        el.replaceWith(heading);
      }
    });
  }
  if (location.pathname.endsWith('/privacy-policy')) {
    body.querySelectorAll('a[href$="/gdpr-request"]').forEach(a => a.remove());
    body.querySelectorAll('a[href="mailto:privacy@downunderthunder.com.au"]').forEach(a => {
      if (a.textContent.trim() === 'admin@downunderthunder.com.au') a.href = 'mailto:admin@downunderthunder.com.au';
    });
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      walker.currentNode.textContent = walker.currentNode.textContent.replace('You can also request this information via this link ', '').replace('"Effective Date" at the top of this page', '"Effective Date" at the bottom of this page');
    }
    // These ordered lists contain section labels, not sequential instructions.
    body.querySelectorAll('ol').forEach(list => {
      const fragment = document.createDocumentFragment();
      [...list.children].forEach(li => {
        if (li.querySelector('p')) fragment.append(...li.childNodes);
        else { const p = document.createElement('p'); p.append(...li.childNodes); fragment.append(p); }
      });
      list.replaceWith(fragment);
    });
    const labels = ['What Personal Information Do We Collect?', 'How Do We Use Your Personal Information?', 'How Do We Share Your Personal Information?', 'How Do We Protect Your Personal Information?', 'Your Rights and Choices', 'Updates to this Privacy Policy', 'Contact Us'];
    body.querySelectorAll('p').forEach(p => {
      const label = labels.find(text => p.textContent.trimStart().startsWith(text));
      if (!label || p.firstChild?.nodeType !== Node.TEXT_NODE) return;
      const text = p.firstChild;
      const start = text.textContent.indexOf(label);
      if (start < 0) return;
      const heading = document.createElement('h2'); heading.textContent = label;
      text.deleteData(start, label.length);
      p.before(heading);
    });
  }
})();
